
import { defineComponent  } from 'vue'
import { useI18n } from 'vue-i18n'
import BuyMore from '@/views/dashboard/service/buy-more/buy-more.vue'

export default defineComponent({
  components: { BuyMore },

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    isPrivate: {
      type: Boolean,
      default: false
    },
  },

  setup (props, context) {
    const { t } = useI18n()
    function handleClose () {
      context.emit('update:modelValue', false)
    }

    return {
      t,
      handleClose
    }
  }
})
